document.addEventListener('turbolinks:load', function() {
    $('.alert-info:contains("Purchase access") .btn-close').on('click', function () {
        updateLastReminded();
    });

    $('a:contains("Purchase")').on('click', function () {
        updateLastReminded();
    });

    function updateLastReminded() {
        const updateRemindedPath = '/purchase/update_last_reminded';
        $.ajax({
            url: updateRemindedPath,
            type: 'POST',
            dataType: 'html'
        });
    }
});